import React, { useState, useEffect } from 'react';
import { withTranslation } from '../../../ChildrenContext.js';
import PropTypes from 'prop-types';
import CheckContent from '../../../CheckContent';
import FormGroup from '../../../FormGroup';

const PayoutItemContent = ({
    isEmpty: propIsEmpty,
    data: propData,
    loading: propLoading,
    getPayout,
    params,
    t
}) => {
    const [isEmpty, setIsEmpty] = useState(propIsEmpty);
    const [data, setData] = useState(propData);
    const [loading, setLoading] = useState(propLoading);

    useEffect(() => {
        getPayout(params.id);
    }, [getPayout, params.id]);

    useEffect(() => {
        setIsEmpty(propIsEmpty);
        setData(propData);
        setLoading(propLoading);
    }, [propIsEmpty, propData, propLoading]);

    const staticNames = t?.payoutItemPage || {};
    const staticNameLabels = t?.dataTable?.headers || {};
    const commonKeys = Object.keys(data.common);
    const paymentMethodKeys = Object.keys(data.paymentMethod);

    return (
        <CheckContent
            loading={loading}
            isEmpty={isEmpty}
        >
            <div className="payout__item-wrapper">
                <div>
                    <div className="ibox">
                        <div className="ibox-title">
                            <h5>{staticNames.generalInfo}</h5>
                        </div>
                        <div className="ibox-content">
                            <div className="form-horizontal form-horizontal_flex">
                                {commonKeys.map((key) => (
                                    <FormGroup
                                        key={key}
                                        label={`${staticNameLabels[key]}:`}
                                    >{data.common[key]}</FormGroup>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
                <div>
                    <div className="ibox">
                        <div className="ibox-title">
                            <h5>{staticNames.paymentMethod}</h5>
                        </div>
                        <div className="ibox-content">
                            <div className="form-horizontal form-horizontal_flex">
                                {paymentMethodKeys.map((key) => (
                                    <FormGroup
                                        key={key}
                                        label={`${staticNameLabels[key]}:`}
                                    >{data.paymentMethod[key]}</FormGroup>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </CheckContent>
    );
};

PayoutItemContent.propTypes = {
    isEmpty: PropTypes.bool,
    data: PropTypes.shape({
        common: PropTypes.object,
        paymentMethod: PropTypes.object,
        currency: PropTypes.object
    }),
    loading: PropTypes.bool,
    getPayout: PropTypes.func.isRequired,
    params: PropTypes.shape({
        id: PropTypes.string.isRequired
    }).isRequired,
    t: PropTypes.object
};

PayoutItemContent.defaultProps = {
    isEmpty: false,
    data: {
        common: {},
        paymentMethod: {},
        currency: {}
    },
    loading: true
};

export default withTranslation(PayoutItemContent);
